import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import GetAllFormFields from '../../../../components/_utils/formUtils'

// import {FormUtils as GetAllFormFields, TableComp} from 'sz-react-utils'
import { Button, Card, Col, Form, Icon, notification, Row, Select, Spin, Table } from 'antd'
import _ from 'lodash'
import { goBack } from 'connected-react-router'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request, { API_URL, LAPI_URL } from '../../../../request'
import { connect } from 'react-redux'
import styles from './styles.less'
import moment from 'moment'


const Option = Select.Option


@Form.create()
class GenerateInvoice extends PureComponent {

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let { inquiryId1, invoiceId1, feedBack } = this.props

                let { invoiceDates, info, invoiceId } = this.state
                let values = _.clone(valData)
                _.each(invoiceDates, (item, key) => {
                    item.invoiceNo = key + 1
                })

                valData._id = this.state.inquiryId
                valData.invoiceId = invoiceId
                valData.nextInvoiceGenerationDates = invoiceDates

                let followUpdata = {

                    date: valData && valData.nextFollowUpDate,
                    detail: valData && valData.nextFollowUpDetails,
                    _id: this.state.inquiryId,
                    followUpType: valData && valData.nextFollowUpType
                }
                dispatch(showLoader())

                let x = await Request.addInvoice(valData)

                dispatch(hideLoader())
                if (!x.error) {
                    let y = await Request.addCounsellingfollowUp(followUpdata)
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })

                    if (feedBack) {
                        feedBack(x.doc)
                    } else {
                        dispatch(goBack())

                    }

                    // this.props.form.resetFields()
                    // this.props.form.setFieldsValue({commission: this.state.commissionValue})
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    setFormValues = async inquiryId => {
        const { form } = this.props
        try {
            let { commissionValue, tutionfeeValue } = this.state
            let { doc } = await Request.getInquiry(inquiryId)
            if (doc) {
                form.setFieldsValue({
                    status: doc.claimDesk && doc.claimDesk.studentStatus,
                    commission: commissionValue,
                    tutionFee: tutionfeeValue,
                    commissionAmount: tutionfeeValue && commissionValue && Math.ceil((tutionfeeValue * commissionValue) / 100)
                })
                this.setState({
                    info: doc,
                    visaDesk: doc.visaDesk,
                    claimDesk: doc.claimDesk,
                    loading: false,
                    loader: false
                })
            }

        } catch (e) {
            console.log(e)
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            invoiceDates: [],
            commissionValue: 0,
            notificationMessage: false,
            loader: true,
            buttonLoading: false,
            tutionfeeValue: 0
        }

    }

    async componentDidMount() {
        const { dispatch } = this.props

        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')
        let invoiceId = searchParams.get('invoiceId')
        let { inquiryId1, invoiceId1 } = this.props
        if (inquiryId1 && invoiceId1) {
            inquiryId = inquiryId1
            invoiceId = invoiceId1
        }

        let { doc } = await Request.getInquiry(inquiryId)

        if (inquiryId) {
            if (doc) {
                let found = _.find(doc.generatedInvoices, (item) => {
                    return item._id == invoiceId
                })
                if (found && found.invoiceGenerationStatus == 'Pending') {
                    this.setState({ singleGeneratedInvoice: found })
                } else {
                    this.setState({ notificationMessage: true })
                }

                let channelPartnerId = doc.visaDesk && doc.visaDesk.channelPartnerId
                let universityId = doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.universityId
                let courseId = doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.courseId

                let { doc: universityData } = await Request.getUniversity(universityId)

                let foundCourseData = _.find(universityData && universityData.course, (item) => {
                    return item._id == courseId
                })

                if (doc.leadSource == 'Channel Partner') {
                    let { doc: channelPartner } = await Request.getPartner(channelPartnerId)
                    this.setState({
                        commissionValue: channelPartner && channelPartner.commission,
                        channelPartnerName: channelPartner && channelPartner.channelPartnerName

                    })
                } else {
                    this.setState({
                        commissionValue: universityData && universityData.commission
                    })
                }

                _.each(doc.nextInvoiceGenerationDates, (item) => {
                    let found = _.find(doc.generatedInvoices, (ii) => {
                        return moment(item.generationDate).format('DD-MMM-YYYY') == moment(ii.invoiceGenerationDate).format('DD-MMM-YYYY')
                    })
                    if (found) {
                        item.showDelete = true
                    }
                })

                this.setState({
                    inquiryId: inquiryId,
                    invoiceDates: doc.nextInvoiceGenerationDates && doc.nextInvoiceGenerationDates.length ? doc.nextInvoiceGenerationDates : [],
                    invoiceId: invoiceId,
                    tutionfeeValue: foundCourseData && foundCourseData.tutionFee
                })
                this.setFormValues(inquiryId);
            }
        } else {
            this.setState({
                loader: false
            })
        }
    }

    render() {
        const { dispatch, form } = this.props
        const {
            info,
            visaDesk,
            channelPartnerName,
            loading,
            invoiceDates,
            singleGeneratedInvoice,
            notificationMessage,
            showDelete
        } = this.state
        const inputSchema = {
            fields: [
                {
                    label: 'Invoice Ref No',
                    key: 'invoiceRefNo',
                    required: true

                },
                {
                    label: 'Invoice Due Date',
                    key: 'dueDate',
                    type: 'date',
                    required: true

                },
                {
                    label: 'Tution Fee',
                    key: 'tutionFee',
                    type: 'number',
                    required: true,
                    onChange: v => {

                        let commissionValue = form.getFieldValue('commission')
                        this.props.form.setFieldsValue({
                            commissionAmount: Math.ceil((v * commissionValue) / 100),
                            tutionFee: v
                        })
                    }
                },
                {
                    label: 'Commission ', key: 'commission', type: 'number',
                    rightComp: <span style={{ paddingLeft: '2px' }}>%</span>,
                    required: true,
                    onChange: v => {
                        let feeValue = form.getFieldValue('tutionFee')
                        this.props.form.setFieldsValue({
                            commissionAmount: Math.ceil((feeValue * v) / 100),
                            commission: v
                        })
                    }
                },
                {
                    label: 'Invoice Amount ', key: 'commissionAmount', type: 'number',
                    disabled: true
                },
                {
                    label: 'Next Follow Up Date',
                    key: 'nextFollowUpDate',
                    type: 'date',
                    required: true
                },
                {
                    label: 'Next Follow Up Details',
                    key: 'nextFollowUpDetails',
                    type: 'textArea',
                    rows: 4,
                    required: true
                },
                {
                    label: 'Next Follow Up Type',
                    key: 'nextFollowUpType',
                    type: 'select',
                    defaultValue: 'Active',
                    options: ['Didn\'t Pick up Call', 'Busy, Call Later', 'Not Interested', 'Out Of town', 'Cold', 'Active'],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            nextFollowUpType: v
                        })
                    },
                    required: true
                },
                {
                    label: 'Upload Invoice',
                    key: 'uploadInvoice',
                    type: 'file',
                    required: true
                }
            ]
        }
        const inputSchema2 = {
            fields: [{
                label: 'Choose and Save Invoice Generation dates',
                key: 'nextInvoiceDate',
                type: 'date',
                extra: '(Vision will give you alert on these dates)',
                rightComp: <Button style={{ marginLeft: '3px' }} type="primary" onClick={() => {
                    let x = [...this.state.invoiceDates]
                    let date = form.getFieldValue('nextInvoiceDate')
                    if (date) {
                        let duplicateDate = _.find(x, (item) => {
                            return moment(item.generationDate).format('DD-MMM-YYYY') == moment(date && date._d).format('DD-MMM-YYYY');
                        })
                        if (duplicateDate) {
                            notification.error({
                                message: 'Date already exists'
                            })
                        } else {
                            x.push({ generationDate: date && date._d })
                            this.setState({ invoiceDates: x }, () => {
                            })
                            this.props.form.setFieldsValue({ nextInvoiceDate: '' })
                        }
                    } else {
                        notification.error({
                            message: 'Select Date'
                        })
                    }
                }}>{<Icon type="plus" />}</Button>
            }]
        }
        const columns = [
            {
                title: 'Invoice No',
                key: 'invoiceNo',
                render: (item, record, key) => {
                    return key + 1
                }
            },
            {
                title: 'Invoice Generation Date',
                key: 'generationDate',
                dataIndex: 'generationDate',
                render: (item, record) => {
                    return (<div>{item ? moment(item).format('DD-MMM-YYYY') : ''}</div>)
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (val, record) => {
                    return <React.Fragment>
                        {record && !record.showDelete &&
                            <Button
                                size={'small'}
                                onClick={() => {
                                    let tt = this.state.invoiceDates
                                    tt = _.reject(tt, val)
                                    this.setState({ invoiceDates: tt })
                                }}>
                                <Icon type={'delete'}></Icon>
                            </Button>
                        }
                    </React.Fragment>
                }
            }
        ]

        const {
            form: { getFieldDecorator }
        } = this.props

        return (
            <PageHeaderWrapper title={'Add Invoice'}>
                <Spin spinning={this.state.loader}>  {notificationMessage ?
                    <Card><h1>Your Invoice Already Processed</h1></Card> :
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <Card bordered={true}>

                            <Row>
                                <Col span={12}>
                                    <table className={styles.dataTable} style={{ width: '90%' }}>
                                        <tbody>
                                            <tr>
                                                <td>Student Name</td>
                                                <td>{info && info.studentName}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoice No.</td>
                                                <td>{singleGeneratedInvoice && singleGeneratedInvoice.invoiceNo}</td>

                                            </tr>
                                            <tr>
                                                <td>Invoice Date</td>
                                                <td>{singleGeneratedInvoice && singleGeneratedInvoice.invoiceGenerationDate ? moment(singleGeneratedInvoice.invoiceGenerationDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>

                                            <tr>
                                                <td>Mobile</td>
                                                <td>{info && info.mobile}</td>
                                            </tr>
                                            <tr>
                                                <td>DOB</td>
                                                <td>{info && info.dateOfBirth ? moment(info.dateOfBirth).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>Branch</td>
                                                <td>{info && info.studentBranchId && info.studentBranchId.branchName}</td>
                                            </tr>
                                            <tr>
                                                <td>Current Desk</td>
                                                <td>{info && info.atLevel}</td>
                                            </tr>
                                            <tr>
                                                <td>Visa Approval Date</td>
                                                <td>29/09/090</td>
                                            </tr>
                                            <tr>
                                                <td>Passport No.</td>
                                                <td>{visaDesk && visaDesk.passportNo}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoicee</td>
                                                <td>
                                                    <div>{info && info.leadSource == 'Channel Partner' ? info.leadSource : 'University'}</div>
                                                    <small>{info && info.leadSource == 'Channel Partner' ? channelPartnerName : ''}</small>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Course Start Date</td>
                                                <td>{visaDesk && visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).format('DD-MM-YYYY') : ''}</td>
                                            </tr>
                                            <tr>
                                                <td>University Name</td>
                                                <td>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.universityInstitutionName}</td>
                                            </tr>
                                            <tr>
                                                <td>Course Name</td>
                                                <td>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseName}</td>
                                            </tr>
                                            <tr>
                                                <td>Student Status</td>
                                                <td>{info && info.studentStatus}</td>
                                            </tr>
                                            <tr>
                                                <td>Invoice Status</td>
                                                <td>{info && info.invoiceStatus}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                    <GetAllFormFields
                                        inputSchema={inputSchema2}
                                        loading={this.props.loading}
                                        apiurl={LAPI_URL}
                                        getFieldDecorator={getFieldDecorator}
                                        formItemLayout={{
                                            labelCol: { span: 12 },
                                            wrapperCol: { span: 12 }
                                        }}
                                    />
                                    {invoiceDates && invoiceDates.length > 0 &&
                                        <Table rowKey={(item, x) => {
                                            return x
                                        }} className={styles.generateInvoiceTableBox}
                                            style={{ marginLeft: '90px', width: '73%' }}
                                            dataSource={invoiceDates || []} columns={columns}
                                            pagination={false} border={true} />}

                                </Col>
                                <Col span={12}>
                                    <GetAllFormFields
                                        inputSchema={inputSchema}
                                        loading={this.props.loading}
                                        apiurl={LAPI_URL}
                                        getFieldDecorator={getFieldDecorator}
                                        formItemLayout={{
                                            labelCol: { span: 10 },
                                            wrapperCol: { span: 12 }
                                        }}
                                    />
                                    <Row>


                                        <Col style={{ textAlign: 'Center' }}>

                                            <Button
                                                htmlType="submit"
                                                style={{
                                                    marginTop: 10,
                                                    backgroundColor: '#85CF4A',
                                                    border: '1px solid #85CF4A',
                                                    color: 'white'
                                                }}
                                                loading={this.props.loading}>
                                                Save Invoice
                                            </Button></Col>
                                    </Row>

                                </Col>
                            </Row>
                        </Card>


                    </Form>}
                </Spin>

            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GenerateInvoice)


